import vehicleDamageFile from '@drivesally/sally-fn/lib/gas/documents/folders/vehicleDamage.document.gas';

// Sections whose pictures aren't simple Gas FK fields - they're Document rows
// tagged to this specific gas object instead of a dedicated field, so they
// need their own query (see GasPictures) and can never show real content in
// the main grid (see hasSectionContent) - keyed by section key -> document
// type to query for.
export default {
  damagePictures: vehicleDamageFile.type,
};
